export const API_KEY = "AIzaSyDBGd_Si22dC-ajRET27zPrHLzU5dV9Tlw";

export default API_KEY;
